import style from "./data-editor-integration-item.module.css";
import { MondayLogo } from "frontend/icons/monday-logo";
import ChevronIcon from "frontend/ui-components/design-system/icons/chevron";

function DataEditorIntegrationItemSkeleton() {
  return (
    <div className={style.container}>
      <div className={style.row}>
        <MondayLogo className={style.mondayLogo} size={16} />
        <span className={style.itemName}>Loading...</span>
        <ChevronIcon className={style.arrow} />
      </div>
      <div className={style.fieldsContainer}>
        <div className={style.separator} />
      </div>
    </div>
  );
}

export default DataEditorIntegrationItemSkeleton;
